import {LocalStorageAdapter} from 'infra/cache';

export const makeLocalStorageAdapter = <T>(): LocalStorageAdapter<T> => new LocalStorageAdapter();
